export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-9.21020fc6.png";